import React from 'react'
import { Cell } from 'rsuite-table'
import './TransactionCell.scss'
import { TransactionStatus } from 'pages/wallet/types'

type TransactionCellProps = {
  rowData?: {
    [key: string]: any
  },
  dataKey: string
}

const TransactionStatusCell: React.FC<TransactionCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey]

  const getStatusClass = (statusValue: string) => {
    switch (statusValue.toLowerCase()) {
      case 'completed':
        return TransactionStatus.COMPLETED
      case 'failed':
        return TransactionStatus.REJECTED
      default:
        return TransactionStatus.OTHER
    }
  }

  return (
    <Cell {...props} className="Transaction-cell">
      <span className={`payment-cell ${getStatusClass(status)}`}>{status}</span>
    </Cell>
  )
}

export default TransactionStatusCell
